import store from '@/store/'

export default function impersonate({ next, router }) {
  if (store.getters['user/ai_admin_only']) {
    if (!store.getters['user/is_impersonate']) {
      return router.push({ name: 'NotFound' })
    }
    return next()
  }

  if (!store.getters['user/show_ai_assistant']) {
    return router.push({ name: 'NotFound' })
  }

  return next()
}
